import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { fmtErr } from "@/lib/api";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 text-white relative overflow-hidden" style={{ background: "var(--ink)" }}>
        <div className="grain absolute inset-0 opacity-20" />
        <Link to="/" className="text-3xl relative z-10"><Logo onDark /></Link>
        <div className="relative z-10">
          <h2 className="font-display text-4xl font-extrabold leading-tight">Discover products<br />you'll love. For Friib.</h2>
          <p className="text-stone-300 mt-4 max-w-sm">Brands provide the product. You just cover shipping. No subscription. No bidding.</p>
        </div>
        <span className="relative z-10 text-stone-500 text-sm">© {new Date().getFullYear()} Friib</span>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="text-2xl lg:hidden block mb-8"><Logo /></Link>
          <h1 className="font-display text-3xl font-extrabold text-stone-900">{title}</h1>
          <p className="text-stone-500 mt-1 mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
export { AuthShell };

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const u = await login(f.email, f.password); toast.success("Welcome back!"); nav(u.role === "admin" ? "/admin" : u.role === "merchant" ? "/merchant" : (sp.get("next") || "/account")); }
    catch (err) { toast.error(fmtErr(err.response?.data?.detail)); setBusy(false); }
  };

  return (
    <AuthShell title="Sign in" subtitle="Welcome back to Friib.">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <input type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <input type="password" required placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <div className="text-right"><Link to="/forgot-password" className="text-sm font-semibold text-stone-500 hover:text-[var(--friib)]">Forgot password?</Link></div>
        <button disabled={busy} data-testid="login-submit" className="w-full py-3.5 rounded-full font-bold text-white disabled:opacity-60" style={{ background: "var(--friib)" }}>{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="mt-6 text-center text-sm text-stone-500">New to Friib? <Link to="/register" className="font-bold text-[var(--friib)]">Create an account</Link></p>
      <div className="mt-6 rounded-xl bg-stone-50 border border-stone-100 p-3 text-xs text-stone-500 text-center">Demo: shopper@friib.com / shopper123 · merchant@friib.com / merchant123</div>
    </AuthShell>
  );
}
